import CustomTable from "@/components/CustomTable";
import { columns } from "./common/columns";
import { useQuery } from "@tanstack/react-query";
import { getAllBalances, getAvailableBalances } from "@/services/Home.service";
import FundAccount from "./common/FundAccount";
import Withdraw from "./common/Withdraw";
import CustomTabs from "@/components/CustomTabs";
import { Skeleton } from "@/components/ui/skeleton";
import { Info } from "lucide-react";

const Balances = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["allBalances"],
    queryFn: async () => await getAllBalances(),
    refetchOnMount: "always",
  });
  const available = useQuery({
    queryKey: ["getAvailableBalances"],
    queryFn: async () => await getAvailableBalances(),
    refetchOnMount: "always",
  });

  return (
    <div className="grid p-6 py-12 gap-[44px]">
      <div className="flex items-center gap-4">
        <div className="flex-col gap-2">
          <p className="text-2xl font-medium text-primary-3">Balances</p>
          <p className="text-base text-gray-80">
            Track and manage your liquidity
          </p>
          <p className="mt-2 flex items-center gap-2 text-xs text-gray-70">
            <Info className="h-4 w-4 shrink-0" />
            Internal Wallex operational balances; provider and bank balances are
            not shown here.
          </p>
        </div>

        <div className="ml-auto flex items-center gap-6">
          <FundAccount />
          <Withdraw balance={data?.data?.data} />
        </div>
      </div>
      <div className="grid gap-6 rounded-[12px] border-[1px] border-[#EAE6EA] p-6 sm:grid-cols-2">
        <div className="grid gap-4">
          <h3 className="text-primary-4 text-sm font-medium">
            Available Balance
          </h3>
          {available?.data?.data?.data === undefined ? (
            <Skeleton className="w-40 h-6" />
          ) : (
            <p className="text-primary-1 font-medium text-2xl">
              {available?.data?.data?.data?.availablelMainBalance?.toLocaleString(
                "en-US",
                {
                  style: "currency",
                  currency: "USD",
                },
              )}
            </p>
          )}
        </div>
        <div className="grid gap-4">
          <h3 className="text-primary-4 text-sm font-medium">
            Pending Balance
          </h3>
          {available?.data?.data?.data === undefined ? (
            <Skeleton className="w-40 h-6" />
          ) : (
            <p className="text-primary-1 font-medium text-2xl">
              {available?.data?.data?.data?.availablelPendingBalance?.toLocaleString(
                "en-US",
                {
                  style: "currency",
                  currency: "USD",
                },
              )}
            </p>
          )}
        </div>
      </div>

      <div className="container mx-auto">
        <CustomTabs
          tabs={["Business Balances", "Customer Balances"]}
          tabData={{
            "Business Balances": (
              <div className="border rounded-md">
                <CustomTable
                  columns={columns}
                  data={data?.data?.data ?? []}
                  // shoePagination={false}
                  isLoading={isLoading}
                />
              </div>
            ),
            "Customer Balances": (
              <div className="flex justify-center items-center">
                <h4 className="text-4xl text-primary-2">Not Available</h4>
              </div>
            ),
          }}
        />
      </div>
    </div>
  );
};
export default Balances;
